// Aurora (DESIGN.md "Glass and depth"): the soft northern-lights glow on its
// own fixed layer behind content, with a faint static grain. It never takes
// pointer events and stops moving under reduced motion. One component for
// the workspace, the session and the public pages; styles are .sg-aurora in
// styles/signal.css, and a surface tunes only the --sg-aurora-* tints.
//
// intensity:
//   "calm"  (workspace, public) a wide field of teal and aqua glows drifting
//           slowly on transform.
//   "focus" (session) two soft pools that move behind the focal element of
//           each moment; `spot` names the position (center, top, halo, orb)
//           and `coach` adds the faint amber pool behind the coach nudge.
// spread: "wide" lets the calm field overscan further (full-bleed entry
//         pages, where the glow reaches the corners).
import React from "react";

const Aurora = ({ intensity = "calm", spot = "center", coach = false, spread, className = "" }) => {
  const focus = intensity === "focus";
  return (
    <div
      aria-hidden="true"
      data-intensity={intensity}
      data-spot={focus ? spot : undefined}
      data-spread={spread}
      className={`sg-aurora ${className}`.trim()}
    >
      {focus ? (
        <>
          <span className="sg-aurora-pool sg-aurora-pool-a" />
          <span className="sg-aurora-pool sg-aurora-pool-b" />
          {coach && <span className="sg-aurora-pool sg-aurora-coach" />}
        </>
      ) : (
        <div className="sg-aurora-field" />
      )}
    </div>
  );
};

export default Aurora;
export { Aurora };
